import * as Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import React from 'react';
import { getPieCellColor } from './utils';

interface PieChartProps<TData extends unknown> {
  data: TData[];
  dataLabelFormatter?: string;
  getDataPoint: (data: TData, index: number) => Partial<Highcharts.Point>;
  seriesName: string;
  titleText?: string;
}

const DATA_LABEL_FORMATTER =
  '<b>{point.name}</b><br/><span style="font-weight: normal">{point.percentage:.2f}%</span>';

const PieChartAlt = <TData extends unknown>(props: PieChartProps<TData>) => {
  const {
    data,
    dataLabelFormatter = DATA_LABEL_FORMATTER,
    getDataPoint,
    seriesName,
    titleText = '',
  } = props;

  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);

  const options = React.useMemo(
    (): Highcharts.Options => ({
      chart: {
        type: 'pie',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: dataLabelFormatter,
          },
        },
      },
      series: [
        {
          colorByPoint: true,
          data: data.map((dataPoint, index) => ({
            ...getDataPoint(dataPoint, index),
            color: getPieCellColor(index),
          })),
          name: seriesName,
        },
      ] as Highcharts.SeriesXrangeOptions[],
      title: {
        text: titleText,
      },
    }),
    [data, dataLabelFormatter, getDataPoint, seriesName, titleText],
  );

  return (
    <HighchartsReact
      ref={chartComponentRef}
      highcharts={Highcharts}
      options={options}
    />
  );
};

export default PieChartAlt;
